<div class="page-detail-wrap vetro-master-bg">
    <h5>{{"Master.certificateType" | translate}}</h5>
</div>
<div class="vetro-bg">
    <div class="vetro-bg">
        <p-table #dt [value]="certificateTypeList"  styleClass="p-datatable-gridlines datatable-vetro"
            [globalFilterFields]="['name']" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,25,50,100]">
            <ng-template pTemplate="caption">
                <div class="d-flex justify-content-between">
                    <span class="p-input-icon-left p-ml-auto" width="300px">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)=" applyFilterGlobal($event,'contains')"
                            placeholder="Search..." />
                    </span>
                    <div class="d-flex table-action-wrap align-items-center">
                        <p-button type="button" icon="pi pi-plus-circle" pRipple class="btn-link mr-3" pTooltip="Add"
                            tooltipPosition="bottom" iconPos="left" (click)="addModal()"
                            label="{{'commonbtn.add'|translate}}">
                        </p-button>
                        <button class="p-button p-button-raised" type="button" icon="pi pi-check" style="width: 100px; justify-content: center;"
                        (click)="export()">
                            {{ "commonbtn.export" | translate }}
                        </button>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>Id</th>
                    <th>Name</th>
                    <th>Sort Order</th>
                    <th>Edit</th>
                    <th>Activate</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-modal>
                <tr
                    [style.backgroundColor]="!modal.isActive ? '#f4f4f4' : ''"
                    [style.color]="!modal.isActive ? '#888' : ''"
                    [style.opacity]="!modal.isActive ? '0.6' : '1'"
                >
                    <td>{{modal.id}}</td>
                    <td>{{modal.name}}</td>
                    <td>{{modal.sortOrder}}</td>
                    <td> <a class="pi pi-pencil" style="color:#fddc88; text-align:center;" (click)="edit(modal)"></a>
                    </td>
                    <td>
                    <p-inputSwitch
                        [style]="{ marginLeft: '1rem' }"
                        [(ngModel)]="modal.isActive"
                        (onChange)="onToggleStatus(modal)"
                    >
                    </p-inputSwitch>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <p-dialog header="{{modalTitle | translate}}" [(visible)]="showModal" [style]="{width: '30vw'}">
        <div class="p-field form-group">
            <div class="row">
                <div class="col-3">
                    <label for="name" style="font-size: medium;" class="col-form-label">Name</label>
                </div>
                <div class="col-9">
                    <input type="text" pInputText id="name" [(ngModel)]="model.name" required />
                </div>
                <div class="col-3">
                    <label for="name" style="font-size: medium;" class="col-form-label">Order Id</label>
                </div>
                <div class="col-9">
                    <input type="text" pInputText id="name" [(ngModel)]="model.sortOrder" required />
                </div>
            </div>
        </div>
        <div class="grid grid-nogutter d-flex justify-content-end">
            <button pButton pRipple label="{{'commonbtn.cancel'|translate}}" icon="pi pi-times" class="btn-cancle"
                (click)="cancel()"></button>
            &nbsp;
            <button pButton pRipple label="{{'commonbtn.save'|translate}}" icon="pi pi-check" styleClass="btn-save"
                (click)="save(model)"></button>
        </div>
	</p-dialog>
</div>